import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, IconButton, Link, Tooltip, Typography } from "@material-ui/core";
import { Delete, Edit, Pageview } from "@material-ui/icons";
import { red } from "@material-ui/core/colors";
import { getPlaylistTooltipAndURL } from "./shared";
export var PlaylistEntryHeader = function (_a) {
    var playlist = _a.playlist, onRemove = _a.onRemove;
    var _b = getPlaylistTooltipAndURL(playlist), tooltip = _b.tooltip, url = _b.url, isEditable = _b.isEditable;
    return (React.createElement(Box, { display: "flex", justifyContent: "space-between" },
        React.createElement(Typography, { variant: "h6" }, "\u041F\u043B\u0435\u0439\u043B\u0438\u0441\u0442"),
        React.createElement(Box, { display: "flex" },
            playlist && (React.createElement(Box, { mr: 1 },
                React.createElement(Tooltip, { title: tooltip },
                    React.createElement(Link, { to: url, component: RouterLink },
                        React.createElement(IconButton, { size: "small" }, isEditable ? React.createElement(Edit, null) : React.createElement(Pageview, null)))))),
            React.createElement(Tooltip, { title: "Удалить" },
                React.createElement(IconButton, { size: "small", onClick: onRemove },
                    React.createElement(Delete, { htmlColor: red[700] }))))));
};
